/**
 * §C.1 · Verificar el correo · `/verificar-correo?token=…`
 *
 * La dirección la fija el servidor: `EnsureAccount` la manda en el correo de alta.
 *
 * ## Devuelve sesión, y por eso entra directamente
 *
 * Lo dice el contrato: «el único momento en que alguien tiene uno de estos tokens es
 * justo después de darse de alta, y mandarlo de vuelta a la pantalla de entrada
 * después de pulsar el enlace de su correo **pierde a la mitad por el camino**».
 *
 * Así que esta pantalla no tiene botón: verifica y entra. Lo único que hace falta es
 * aguantar que el cliente de correo abra el enlace antes que la persona — el token es
 * de un solo uso, igual que el del enlace mágico.
 */
import { useEffect, useRef, useState } from 'react';
import { api } from '@/shared/api/client';
import { aProblema, type Problema } from '@/shared/api/errores';
import { useSesion } from '@/shared/auth/sesionContexto';
import { Cargando } from '@/shared/ui/Estados';

export function VerificarCorreo({ token }: { token: string }) {
  const { entrar } = useSesion();
  const [problema, setProblema] = useState<Problema | null>(null);
  const canjeado = useRef(false);

  useEffect(() => {
    if (canjeado.current) return;
    canjeado.current = true;

    void (async () => {
      const { data, error } = await api.v1.auth.email.verify.post({ token });

      if (error || !data) {
        setProblema(aProblema(error));
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('token');
      window.history.replaceState(null, '', url);

      await entrar((data as unknown as { access_token: string }).access_token);
    })();
  }, [token, entrar]);

  if (!problema) return <Cargando filas={2} etiqueta="Verificando tu correo" />;

  const gastado = problema.status === 410 || problema.status === 404;

  return (
    <main className="acceso">
      <div className="tarjeta">
        <h1>{gastado ? 'Este enlace ya se usó' : problema.title}</h1>
        <p>
          {gastado
            ? 'Vale una sola vez, y a veces lo gasta el propio programa de correo al previsualizarlo. Si ya habías verificado tu dirección, entra con normalidad.'
            : problema.detail}
        </p>
        <button type="button" onClick={() => window.location.assign('/')}>
          Ir al acceso
        </button>
      </div>
    </main>
  );
}
